import { useCallback } from 'react';
import { useDispatchApp } from 'redux/rootSelectors';
import {
  initialState as stateAgency,
  setTempImage as setAgency,
} from 'domains/agency/reducer';
import {
  initialState as stateClient,
  setTempImage as setClient,
} from 'domains/client/reduser';

type TFUseClearLinkImage = () => () => void;

export const useClearLinkImage: TFUseClearLinkImage = () => {
  const dispatch = useDispatchApp();
  return useCallback(() => {
    dispatch(setAgency(stateAgency.tempImage));
    dispatch(setClient(stateClient.tempImage));
  }, [dispatch]);
};
